import { TIsDateBeforeArguments } from '../domains/types';
import dayjs from '../dayjsConfig';

const isDateBefore = ({
  firstDate,
  secondDate,
  unit,
  dateInUTC,
  timeZone,
}: TIsDateBeforeArguments) => {
  if (dateInUTC) {
    return (timeZone ? dayjs(firstDate).utc().tz(timeZone) : dayjs(firstDate).utc())
      .isBefore(timeZone
        ? dayjs(secondDate).utc().tz(timeZone)
        : dayjs(secondDate).utc(), unit,
      );
  }

  return (timeZone ? dayjs(firstDate).tz(timeZone) : dayjs(firstDate))
    .isBefore(timeZone ? dayjs(secondDate).tz(timeZone) : dayjs(secondDate), unit);
};

export default isDateBefore;
